import { FileDefinitionDTO } from "../DTO/fileDefinitionDTO";
import { MetadataInfoDTO } from "../DTO/metadataInfoDTO";
import { AnalyzerFieldDefinition, AnalyzerFileDefinition } from "../responses/analyzeCSVResponse";
import { FieldDefinition } from "./fieldDefinition";
import { MetadataInfo } from "./metadataInfo";

export class FileDefinition{
    public id? : number;
    public name! : string;
    public type! : string; //csv or fl
    public hasHeader! : boolean; //indicates if the file received will have a header row.
    public fieldDelimiter?:string; //for csv files
    public unevenRows?:boolean;// csv: if rows can be of different length=>affects the file validation logic
    public version? : number; //incremental version number set by server
    public published : boolean = false; //if true, then can be used for moovs and can be loaded by other users
    public added? : Date;
    public deleted : boolean = false;
    public fieldDefinitions : FieldDefinition[] = [];
    public ownedByEntityId?: number;
    public ownerEntityType?: string;
    public scopeRestrictions?: string[];
    public defaultMetadataProtocol? :MetadataInfo[];
    public abstractForIntegrationType? : number;
    public abstractForPremierPartnerId? : number;
    public wizardSessionId?: number;

    constructor(){
    }

    public static mapFromDTO(param:FileDefinitionDTO, obj?:FileDefinition):FileDefinition{ 
        if (!param) throw new Error("parameter is null")
        if(!obj) obj = new FileDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.type = param.type;
            obj.hasHeader = param.hasHeader;
            obj.fieldDelimiter = param.fieldDelimiter;
            obj.unevenRows = param.unevenRows;
            let fdArray:any[] = JSON.parse(param.fieldDefinition);
            //remove no longer existing field definitions
            obj.fieldDefinitions = obj.fieldDefinitions.filter(fd=>fdArray.findIndex(element=>element.index==fd.index)>-1);
            //create or update/delete existing fielddefinitions
            fdArray.forEach(fd=>{
                let index = obj.fieldDefinitions.findIndex(element=>element.index==fd.index);
                let fieldDefinition = Object.assign(new FieldDefinition(),fd);
                if(index>-1){
                    obj.fieldDefinitions[index].updateFieldDefinition(fieldDefinition);
                }
                else{
                    obj.fieldDefinitions.push(fieldDefinition);
                }
            });
            
            obj.version = param.version;
            obj.published = param.published;
            if(param.added) obj.added = new Date(param.added);
            obj.deleted = param.deleted;
            obj.ownedByEntityId = param.ownedByEntityId;
            obj.ownerEntityType = param.ownerEntityType;
            if(param.scopeRestrictions && param.scopeRestrictions.length>0) obj.scopeRestrictions = param.scopeRestrictions.split(',');
            if(param.defaultMetadataProtocol) obj.defaultMetadataProtocol = FileDefinition.deserializeMetadataInfo(param.defaultMetadataProtocol);
            obj.abstractForIntegrationType = param.abstractForIntegrationType;
            obj.abstractForPremierPartnerId = param.abstractForPremierPartnerId;
            obj.wizardSessionId = param.wizardSessionId;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:FileDefinition):FileDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new FileDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.type = param.type;
            dto.hasHeader = param.hasHeader;
            dto.fieldDelimiter = param.fieldDelimiter; 
            dto.unevenRows = param.unevenRows;
            if(param.fieldDefinitions && param.fieldDefinitions.length) dto.fieldDefinition = JSON.stringify(param.fieldDefinitions);
            dto.version = param.version;
            dto.published = param.published;
            dto.deleted = param.deleted;
            dto.ownedByEntityId = param.ownedByEntityId;
            dto.ownerEntityType = param.ownerEntityType;
            if(param.added) dto.added = param.added.toISOString();
            if(param.scopeRestrictions && param.scopeRestrictions.length>0) dto.scopeRestrictions = param.scopeRestrictions.join(',');
            if(param.defaultMetadataProtocol) dto.defaultMetadataProtocol = FileDefinition.serializeMetadataInfo(param.defaultMetadataProtocol);
            dto.abstractForIntegrationType = param.abstractForIntegrationType;
            dto.abstractForPremierPartnerId = param.abstractForPremierPartnerId;
            dto.wizardSessionId = param.wizardSessionId;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    public static mapFromAnalyzer(param:AnalyzerFileDefinition):FileDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new FileDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.type = 'csv'
            obj.hasHeader = param.hasHeader;
            obj.fieldDelimiter = param.fieldDelimiter;
            obj.unevenRows = param.unevenRows;
            param.fields.forEach(fd=>{
                let fieldDefinition = new FieldDefinition();
                fieldDefinition.index = fd.index;
                fieldDefinition.name = fd.fieldName;
                fieldDefinition.dataType = fd.dataType;
                fieldDefinition.dataPattern = fd.dataPattern;
                fieldDefinition.mandatory = fd.mandatory;
                fieldDefinition.isOutputParameter = fd.isOutputParameter;
                obj.fieldDefinitions.push(fieldDefinition);
            });
            obj.version = 1;
            obj.published = false
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToAnalyzer(param:FileDefinition):AnalyzerFileDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new AnalyzerFileDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.hasHeader = param.hasHeader;
            obj.fieldDelimiter = param.fieldDelimiter;
            obj.unevenRows = param.unevenRows;
            param.fieldDefinitions.forEach(fd=>{
                let fieldDefinition = new AnalyzerFieldDefinition();
                fieldDefinition.index = fd.index;
                fieldDefinition.fieldName = fd.name;
                fieldDefinition.dataType = fd.dataType;
                fieldDefinition.dataPattern = fd.dataPattern;
                fieldDefinition.mandatory = fd.mandatory;
                fieldDefinition.isOutputParameter = fd.isOutputParameter;
                obj.fields.push(fieldDefinition);
            });
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    private static deserializeMetadataInfo(value:string){
        let metadataInfoArray:MetadataInfo[] = [];
        if(value){
            let mdiArray=JSON.parse(value);
            mdiArray.forEach((mdi:MetadataInfoDTO)=>{
                metadataInfoArray.push(MetadataInfo.mapFromDTO(mdi));
            });
        }
        return metadataInfoArray;
    }

    private static serializeMetadataInfo(mdiArray:MetadataInfo[]){
        let metadataInfoDTOArray:MetadataInfoDTO[] = [];
        if(mdiArray?.length>0){
            metadataInfoDTOArray=[];
            mdiArray.forEach(mdi=>{
                metadataInfoDTOArray.push(MetadataInfo.mapToDTO(mdi));
            });
        }
        return JSON.stringify(metadataInfoDTOArray);
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }

    public getFieldDefinitionsByDataType(dataType:string){
        return this.fieldDefinitions.filter(fd=>dataType?fd.dataType==dataType:fd);
    }

    get inputFieldNames():string[]{
        //in lower case for duplicate comparison
        return this.fieldDefinitions.map(fd=>fd.name.toLowerCase());
    }
    get inputFieldIndex():number[]{
        //in lower case for duplicate comparison
        return this.fieldDefinitions.map(fd=>fd.index);
    }

    // use DTO to create a deep copy
    get clone():FileDefinition{
        let mappedFileDefinition=FileDefinition.mapToDTO(this);
        mappedFileDefinition.id=0;
        mappedFileDefinition.name="";
        mappedFileDefinition.version=0;
        mappedFileDefinition.published=false;
        return FileDefinition.mapFromDTO(mappedFileDefinition);
    }
}

